import { createSlice } from "@reduxjs/toolkit";

export const localeSlice = createSlice({
  name: "locale",
  initialState: {
    lang: "en",
    dir: "ltr",
  },
  reducers: {
    changeLang: (state, action) => {
      state.lang = action.payload.lang;
      state.dir = action.payload.dir;
    },
  },
});

const { reducer, actions } = localeSlice;
export const { changeLang } = actions;

export default reducer;
